import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Template from "./template/Template";
import ProductDetail from "./products/detail/ProductDetail";
import Landing from "./landing/Landing";
import ProductList from "./products/ProductList";
import Checkout from "./products/Checkout";
import AdminProducts from "./products/AdminProducts";
import AdminRoute from "./admin/AdminRoute"
function App() {
  return (
    <BrowserRouter>
      <Template>
        <Switch>
          {/* All products */}
          <Route path="/products" exact component={ProductList} />
          <Route path="/products/category/:category" component={ProductList} />
          <Route path="/products/:id" component={ProductDetail} />
          <Route path="/checkout" component={Checkout} />
          <AdminRoute path="/admin-product" component={AdminProducts} />
          <Route path="/" exact component={Landing} />
        </Switch>
      </Template>
    </BrowserRouter>

  );
}

export default App;
